import React, { useState, useEffect } from 'react'

import CopyButton from './CopyButton'

const Component = ({
  text
}) => {
  const [copied, setCopied] = useState(false)
  const onCopy = () => {
    setCopied(true)
    setTimeout(() => setCopied(false), 1000)
  }

  const [enabled, setEnabled] = useState(false)
  useEffect(() => setEnabled(true), [])

  return <CopyButton 
    enabled={enabled}
    text={text}
    onCopy={onCopy}
    copied={copied} />
}

export default Component